import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import SelectFild from '../../components/SelectFild/SelectFild';
import DateFild from '../../components/DateTimePicker/DateFild';
import { useFormik } from 'formik';
import { postProjectSave } from '../../apiservices/ApiServices';

const emptyProject = {
    phaseName: '',
    dueDate: '',
    amount: '',
};

const mapEditDataToFormValues = (editData) => {
    const setting = editData?.billing_phase_setting;
    if (!setting) {
        return {
            billingStructure: '',
            billingBasedOn: '',
            calculationType: '',
            fullActivityWise: '',
            fullDateWise: '',
            phases: [{ ...emptyProject }],
        };
    }

    const phasess = (setting.phases || []).map((prod) => ({
        phaseName: prod.phase_name || '',
        dueDate: prod.due_date || '',
        amount: prod.bill_value || '',
    }));

    return {
        billingStructure: setting.billing_structure || 'full',
        billingBasedOn: setting.billing_based_on || 'due_date',
        calculationType: setting.calculation_type || 'percentage',
        fullActivityWise: setting.sub_activity_id || '',
        fullDateWise: setting.due_date || '',
        phases: phasess.length ? phasess : [{ ...emptyProject }],
    };
};

const StepThree = (props) => {
    const formik = useFormik({
        initialValues: mapEditDataToFormValues(props.editData),
        enableReinitialize: true,
        onSubmit: async (values) => {
            props.setLoadings(true);

            let postData;

            if (values.billingStructure == 'phase') {
                postData = {
                    project_id: props.ids,
                    step: 'billing_phase_setting',
                    data: {
                        billing_structure: values.billingStructure,
                        billing_based_on: values.billingBasedOn,
                        calculation_type: values.calculationType,
                        phases: values.phases.map((item) => ({
                            phase_name: item?.phaseName,
                            due_date: item?.dueDate,
                            bill_value: item?.amount,
                        })),
                    }
                }
            }
            else {
                if (values.billingBasedOn == 'due_date') {
                    postData = {
                        project_id: props.ids,
                        step: 'billing_phase_setting',
                        data: {
                            billing_structure: values.billingStructure,
                            billing_based_on: values.billingBasedOn,
                            due_date: values.fullDateWise,
                        }
                    }
                }
                else {
                    postData = {
                        project_id: props.ids,
                        step: 'billing_phase_setting',
                        data: {
                            billing_structure: values.billingStructure,
                            billing_based_on: values.billingBasedOn,
                            sub_activity_id: values.fullActivityWise,
                        }
                    }
                }
            }

            try {
                const res = await postProjectSave(postData);
                props.Toast.success(res.data.message);
                let proid = res?.data?.data?.project_id;
                props.setIds(proid);
                props.postProductRoleLists(proid);
                props.setLoadings(false);
                props.setStep(4);

            } catch (error) {
                props.setLoadings(false);
                props.Toast.error(error.response?.data?.message || "Error submitting data");
            }
        }
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const addPhase = () => {
        setFieldValue('phases', [...values.phases, { ...emptyProject }]);
    };

    const removePhase = (index) => {
        const updated = values.phases.filter((_, i) => i !== index);
        setFieldValue('phases', updated);
    };

    return (
        <form onSubmit={handleSubmit} autoComplete="off">
            <div className='fieldsets cols_5'>
                <div className='fieldsets-title'>Project Billing Phases</div>
                <Row>
                    <Col md={3}>
                        <div className="form-group">
                            <label className="form-label">Billing Structure</label>
                            <ul className='radiolist'>
                                <li>
                                    <div className='radioBox'>
                                        <input
                                            type="radio"
                                            name="billingStructure"
                                            value={'full'}
                                            checked={values.billingStructure == 'full'}
                                            onChange={(e) => { setFieldValue('billingStructure', e.target.checked ? 'full' : ''); }}
                                            onBlur={handleBlur}
                                        />
                                        <span className='rdoMark'></span>
                                        <label>Full</label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radioBox'>
                                        <input
                                            type="radio"
                                            name="billingStructure"
                                            value={'phase'}
                                            checked={values.billingStructure == 'phase'}
                                            onChange={(e) => { setFieldValue('billingStructure', e.target.checked ? 'phase' : ''); }}
                                            onBlur={handleBlur}
                                        />
                                        <span className='rdoMark'></span>
                                        <label>Phase-wise</label>
                                    </div>
                                </li>
                            </ul>
                            {errors.billingStructure && touched.billingStructure && (
                                <p className="errormsg">{errors.billingStructure}</p>
                            )}
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="form-group">
                            <label className="form-label">Billing based on</label>
                            <ul className='radiolist'>
                                <li>
                                    <div className='radioBox'>
                                        <input
                                            type="radio"
                                            name="billingBasedOn"
                                            value={'due_date'}
                                            checked={values.billingBasedOn == 'due_date'}
                                            onChange={(e) => { setFieldValue('billingBasedOn', e.target.checked ? 'due_date' : ''); }}
                                            onBlur={handleBlur}
                                        />
                                        <span className='rdoMark'></span>
                                        <label>Due Date Wise</label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radioBox'>
                                        <input
                                            type="radio"
                                            name="billingBasedOn"
                                            value={'activity'}
                                            checked={values.billingBasedOn == 'activity'}
                                            onChange={(e) => { setFieldValue('billingBasedOn', e.target.checked ? 'activity' : ''); }}
                                            onBlur={handleBlur}
                                        />
                                        <span className='rdoMark'></span>
                                        <label>Activity Wise</label>
                                    </div>
                                </li>
                            </ul>
                            {errors.billingBasedOn && touched.billingBasedOn && (
                                <p className="errormsg">{errors.billingBasedOn}</p>
                            )}
                        </div>
                    </Col>
                    {values.billingStructure == 'full' &&
                        <>
                            {values.billingBasedOn == 'due_date' &&
                                <Col md={3}>
                                    <div className="form-group">
                                        <label className="form-label">Due Date</label>
                                        <DateFild
                                            value={values.fullDateWise}
                                            onChange={(date) => setFieldValue('fullDateWise', date)}
                                        />
                                    </div>
                                </Col>
                            }

                            {values.billingBasedOn == 'activity' &&
                                <Col md={3}>
                                    <div className="form-group">
                                        <label className="form-label">Select Activity</label>
                                        <SelectFild
                                            Firstop='Select Activity'
                                            selectName="fullActivityWise"
                                            options={(props.activityList).map(items => ({
                                                id: items.sub_activity_id,
                                                name: items.sub_activity_name
                                            }))}
                                            value={values.fullActivityWise}
                                            onChange={(selectedOption) => setFieldValue("fullActivityWise", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.fullActivityWise && touched.fullActivityWise && (
                                            <p className="errormsg">{errors.fullActivityWise}</p>
                                        )}
                                    </div>
                                </Col>
                            }
                        </>
                    }
                    {values.billingStructure == 'phase' &&
                        <Col md={3}>
                            <div className="form-group">
                                <label className="form-label">Calculation Type</label>
                                <ul className='radiolist'>
                                    <li>
                                        <div className='radioBox'>
                                            <input
                                                type="radio"
                                                name="calculationType"
                                                value={'percentage'}
                                                checked={values.calculationType == 'percentage'}
                                                onChange={(e) => { setFieldValue('calculationType', e.target.checked ? 'percentage' : ''); }}
                                                onBlur={handleBlur}
                                            />
                                            <span className='rdoMark'></span>
                                            <label>Percentage</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='radioBox'>
                                            <input
                                                type="radio"
                                                name="calculationType"
                                                value={'amount'}
                                                checked={values.calculationType == 'amount'}
                                                onChange={(e) => { setFieldValue('calculationType', e.target.checked ? 'amount' : ''); }}
                                                onBlur={handleBlur}
                                            />
                                            <span className='rdoMark'></span>
                                            <label>Amount</label>
                                        </div>
                                    </li>
                                </ul>
                                {errors.calculationType && touched.calculationType && (
                                    <p className="errormsg">{errors.calculationType}</p>
                                )}
                            </div>
                        </Col>
                    }
                </Row>
                {values.billingStructure == 'phase' && values.calculationType != '' && values.calculationType != '' &&
                    <>
                        {values.phases.map((phases, index) => (
                            <div key={index} className="fieldsets mainFS">
                                <div className='fieldsetsboxs'>
                                    <h6>Phase {index + 1}</h6>
                                    <div className="addreovebtns">
                                        <button type="button" className="btn add-btn" onClick={addPhase}>+</button>
                                        {values.phases.length > 1 && (
                                            <button type="button" className="btn remove-btn" onClick={() => removePhase(index)}>-</button>
                                        )}
                                    </div>
                                </div>
                                <div className='formsBox'>
                                    <Row>
                                        {values.billingBasedOn == 'activity' &&
                                            <>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label className="form-label">Select Activity</label>
                                                        <SelectFild
                                                            Firstop='Select Activity'
                                                            selectName={`phases[${index}].phaseName`}
                                                            options={(props.activityList).map(items => ({
                                                                id: items.sub_activity_id,
                                                                name: items.sub_activity_name
                                                            }))}
                                                            value={phases.phaseName}
                                                            onChange={(selectedOption) => setFieldValue(`phases[${index}].phaseName`, selectedOption?.value || "")}
                                                            onBlur={() => handleBlur(`phases[${index}].phaseName`)}
                                                        />
                                                    </div>
                                                </Col>
                                            </>
                                        }
                                        {values.billingBasedOn == 'due_date' &&
                                            <>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label className="form-label">Phase Name</label>
                                                        <input
                                                            type='text'
                                                            name={`phases[${index}].phaseName`}
                                                            className="form-control"
                                                            autoComplete='off'
                                                            value={phases.phaseName}
                                                            onChange={(e) => setFieldValue(`phases[${index}].phaseName`, e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label className="form-label">Phase Due Date</label>
                                                        <DateFild
                                                            value={phases.dueDate}
                                                            onChange={(date) => setFieldValue(`phases[${index}].dueDate`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                            </>
                                        }
                                        {values.calculationType == 'amount' &&
                                            <Col md={3}>
                                                <div className="form-group">
                                                    <label className="form-label">Phase Amount</label>
                                                    <input
                                                        type='text'
                                                        name={`phases[${index}].amount`}
                                                        className="form-control"
                                                        autoComplete='off'
                                                        value={phases.amount}
                                                        onChange={(e) => setFieldValue(`phases[${index}].amount`, e.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                        }
                                        {values.calculationType == 'percentage' &&
                                            <Col md={3}>
                                                <div className="form-group">
                                                    <label className="form-label">Phase Percentage</label>
                                                    <input
                                                        type='text'
                                                        name={`phases[${index}].amount`}
                                                        className="form-control"
                                                        autoComplete='off'
                                                        value={phases.amount}
                                                        onChange={(e) => setFieldValue(`phases[${index}].amount`, e.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                        }
                                    </Row>
                                </div>
                            </div>
                        ))}
                    </>
                }
                <div className='button-boxs grid'>
                    <button type='submit' className='btn btn-primary'>Save</button>
                </div>
            </div>
        </form>
    )
}

export default StepThree